export enum RatingSizeEnum {
  MEDIUM = 'medium',
  SMALL = 'small',
}
